var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApyGraph3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 38,
    viewBox: "0 0 113 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.23652L4.85097 7.12841L7.09739 9.35816L14.1576 2L16.7249 4.11826L17.6876 6.23652L20.2549 4.11826L22.5014 5.56759L26.3523 3.67231L30.8452 9.24667H35.0171L37.5844 11.8109H39.5099L42.3981 15.044L44.6446 15.6014L45.6073 10.919L51.0628 17.7197L57.1602 16.4933L58.7648 15.6014L60.3694 21.3988L62.6158 18.8346H65.504L69.0341 25.4123L70.9596 23.963L75.7734 23.517L79.3034 21.7332L81.2289 20.9528L86.0426 31.6554L88.61 29.8716L90.5355 35L95.0282 27.1961L96.9538 26.4157L99.842 29.8718L100.805 23.517L103.693 22.1792L105.298 19.615L107.638 21.7332L110.061 25.4123L112 29.8716",
    stroke: "#EB5757",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApyGraph3);
export default __webpack_public_path__ + "static/media/apyGraph3.2a690d586178881b4ad01003b07d708a.svg";
export { ForwardRef as ReactComponent };